var cartItemsContainer = null;
var quantity = 0;
$(document).ready(function () {
  cartItemsContainer = $(".drawer__content");
  // when item is add to cart
  addEventListenerForProductAddToCart(cartItemsContainer);
  addEventListenersForCart();
});
function addEventListenersForCart() {
  addEventListenerForRemoveProduct(cartItemsContainer);
  addEventListenerForAddProduct(cartItemsContainer);
  addEventListenerForSubtractProduct(cartItemsContainer);
}
function addEventListenerForRemoveProduct(cartItemsContainer) {
  $(".remove-button").click(function (event) {
    let variantId = event.target.getAttribute("data-variant-id");
    fetch(`/cart/change.js?quantity=0&id=${variantId}`, {
      method: "POST",
    })
      .then((response) => response.json())
      .then((r) => {
        console.log("Product removed from cart:", r);
        updateCartHtml(r, 0);
      });
  });
}
function addEventListenerForAddProduct(cartItemsContainer) {
  $(".plus").click(function (event) {
    let variantId = event.target.getAttribute("data-variant-id");
    let variantQuantity = document.querySelector(
      `#Quantity-${variantId}`
    ).value;
    fetch(`/cart/change.js?quantity=${variantQuantity}&id=${variantId}`, {
      method: "POST",
    })
      .then((response) => response.json())
      .then((r) => {
        console.log("Product added to cart:", r);
        updateCartHtml(r, 0);
      });
  });
}
function addEventListenerForSubtractProduct(cartItemsContainer) {
  $(".minus").click(function (event) {
    let variantId = event.target.getAttribute("data-variant-id");
    let variantQuantity = document.querySelector(
      `#Quantity-${variantId}`
    ).value;
    fetch(`/cart/change.js?quantity=${variantQuantity}&id=${variantId}`, {
      method: "POST",
    })
      .then((response) => response.json())
      .then((r) => {
        console.log("Product removed from cart:", r);
        updateCartHtml(r, 0);
      });
  });
}
function addEventListenerForProductAddToCart(cartItemsContainer) {
  $('button[type="submit"]').click(function (event) {
    const addToCartButton = $(this);
    cartItemsContainer.html("Updating cart...");
    const form = addToCartButton.closest("form");
    const variantId = form.find('input[name="id"]').val();
    quantity = form.find('input[name="quantity"]').val();
    addVariantToCart(variantId, quantity);
  });
}
function addVariantToCart(variantId, quantity) {
  const requestData = {
    items: [
      {
        id: variantId,
        quantity: quantity,
      },
    ],
  };
  $.ajax({
    url: "/cart/add.js",
    type: "GET",
    dataType: "json",
    data: requestData,
    success: function (addToCartResponse) {
      console.log("Product added to cart:", addToCartResponse);
      updateCartHtml(addToCartResponse, 0);
    },
    error: function (addToCartError) {
      console.error("Error adding product to cart:", addToCartError);
      cartItemsContainer.html("Error adding product to cart");
    },
  });
}
function updateHeaderCount(quantity) {
  const headerCount = $("span#cart-icon-bubble");
  const currentCount = parseInt(headerCount.text());
  const newCount = parseInt(quantity);
  headerCount.text(newCount);
  console.log(newCount);
  headerCount.addClass("shown");
  return newCount;
}
function updateCartHtml(addToCartResponse, newCount) {
  $.ajax({
    url: "/cart.js",
    type: "GET",
    dataType: "json",
    success: function (getCartResponse) {
      let cartItemsHtml = "";
      let totalPrice = 0;
      newCount = getCartResponse.item_count;
      for (let i = 0; i < getCartResponse.items.length; i++) {
        const item = getCartResponse.items[i];
        const itemHtml = getItemHTML(getCartResponse, item, i);
        cartItemsHtml += itemHtml;
        totalPrice += item.price * item.quantity;
      }

      // Calculate the remaining amount needed for free shipping
      const freeShippingThreshold = 7500; // $250 in cents
      const remainingForFreeShipping = freeShippingThreshold - totalPrice;

      // Create a progress bar HTML element
      const progressBarHtml = `
        <div class="progress-bar">
         <div class="progress" style="width: ${Math.min(
           (totalPrice / freeShippingThreshold) * 100,
           100
         )}%;"></div>

        </div>
        <div class="remaining-for-free-shipping">
          ${
            remainingForFreeShipping <= 0
              ? "You qualify for free shipping!"
              : `Spend $${
                  remainingForFreeShipping / 100
                } more for free shipping`
          }
        </div>
      `;

      const totalHtml = `<div class="total-price">Estimated total: $ ${
        totalPrice / 100
      }</div>`;
      const viewCart = `<a id="view_cart_btn" href="/cart" class="btn btn--has-icon-after cart__continue-btn" style="width:100%;">View Cart(${newCount})</a>`;
      const checkBtn = `<a id="cart__checkout_btn" href="/checkout" class="btn btn--has-icon-after cart__continue-btn" style="width:100%;">Proceed Checkout</a>`;
      const cartHtml = `${progressBarHtml}${cartItemsHtml}`;
      const buttonsDiv = document.createElement("div");
      buttonsDiv.classList.add("bottom-container");
      buttonsDiv.innerHTML = `${totalHtml}${viewCart}${checkBtn}`;
      updateHeaderCount(newCount);
      cartItemsContainer.html(cartHtml);
      cartItemsContainer.append(buttonsDiv);
      addEventListenersForCart(cartItemsContainer);
    },
    error: function (getCartError) {
      console.error("Error updating cart:", getCartError);
      cartItemsContainer.html("Error updating cart");
    },
  });
}

function getItemHTML(getCartResponse, item, i) {
  const imageUrl = item.image
    ? item.image.replace(/(\.[^\.]+)$/, "_medium$1")
    : "";
  const imageHtml = `<img class="item-image" src="${imageUrl}" alt="${item.title}"
width="100" height="100">`;
  const titleHtml = `<div class="item-title">${item.title}</div>`;
  const priceHtml = `<div class="item-price">$ ${item.price / 100}</div>`;
  let itemQty = item.quantity;
  const quantityHtml = `
<quantity-input class="quantity">
<button class="quantity__button no-js-hidden minus"
data-variant-id="${item.variant_id}" name="minus" type="button">
<span class="visually-hidden">Decrease quantity for ${item.title}</span>
<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
<path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110
1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
</svg>
</button>
<input class="quantity__input"
type="number"
name="updates[]"
value="${itemQty}"
min="0"
aria-label="Quantity for ${item.title}"
id="Quantity-${item.variant_id}"
data-index="${quantity}">
<button class="quantity__button no-js-hidden plus"
data-variant-id="${item.variant_id}" name="plus" type="button">
<span class="visually-hidden">Increase quantity for ${item.title}</span>
<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01
3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1
.01v3.5l-3.5.01H1z" fill="currentColor"></path>
</svg>
</button>
</quantity-input>
`;
  const removeButton = `<button class="remove-button"
data-variant-id="${item.variant_id}">Remove</button>`;
  // Create a container div to store the elements
  const containerDiv = document.createElement("div");
  containerDiv.classList.add("item-container");
  containerDiv.innerHTML = `${imageHtml}${titleHtml}${priceHtml}${quantityHtml}${removeButton}`;
  return containerDiv.outerHTML;
}
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const removeButtons = document.querySelectorAll(".cart__remove-btn");
    removeButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const variantId = button.dataset.variantId;
        fetch(`/cart/change.js?quantity=0&id=${variantId}`, {
          method: "POST",
        })
          .then((response) => response.json())
          .then((data) => {
            const cartCount = document.querySelector("span#cart-icon-bubble");
            cartCount.textContent = data.item_count;
            const item = document.querySelector(`.item-container-${variantId}`);
            item.parentNode.removeChild(item);
            const totalPrice = document.querySelector("#cart__total_price");
            totalPrice.textContent = formatMoney(data.total_price);
          })
          .catch((error) => {
            console.error(error);
          });
      });
    });
  }, 2000); // Delay execution for 2000 milliseconds (2 seconds)

  function formatMoney(amount) {
    return `$${(amount / 100).toFixed(2)}`;
  }
});

